import { Button } from "antd";
import TypeClassButton from "./typeClassButton.js";
import { Link } from "react-router-dom";

function TypeClass({
  suggestion,
  table,
  row,
  interactiveSearch,
  isQuickSearch,
  interactiveAdvancedSearch,
  showEnzymePopups,
}) {
  const DISABLED_CONDITION = suggestion == undefined ? false : true;

  const TypeObject = {
    di: ["di", "Diterpene", "DiTerpInput"],
    mono: ["mono", "Monoterpene", "MonoTerpInput"],
    sesq: ["sesq", "Sesquiterpene", "SesqTerpInput"],
    tetra: ["tetra", "Tetraterpene", "TetraTerpInput"],
    sester: ["sester", "Sesterterpene", "SesterTerpInput"],
    sesquar: ["sesquar", "Sesquarterpene", "SesquarTerpInput"],
    tri: ["tri", "Triterpene", "TriTerpInput"],
    prenyl: ["pt", "Isoprenyl diphosphate", "PrenylTerpInput"],
    hemi: ["hemi", "Hemiterpene", "HemiTerpInput"],
    sqs: ["sqs", "Squalene ", "SqsTerpInput"],
    psy: ["psy", "Phytoene", "PsyTerpInput"],
    mero: ["mero", "Meroterpenoid", "MeroTerpInput"]
  };

  const ClassObject = {
    one: [1, `Class I`,"ClassI"],
    two: [2, `Class II`,"ClassII"],
  };

  function handleClickType(type, key, value, input) {
    return isQuickSearch
      ? interactiveSearch(type)
      : interactiveAdvancedSearch(showEnzymePopups, key, value, input);
  }

  function handleClickClass(classNumber, key, value, input) {
    return isQuickSearch
      ? interactiveSearch(classNumber)
      : interactiveAdvancedSearch(showEnzymePopups, key, value, input);
  }

  return (
    <div>
      {table[row].enzyme_marts && <Link className="plane-text-button" to={`/record/${table[row].enzyme_marts}`} style={{paddingRight: "0px"}}>
        {table[row].enzyme_marts}, </Link>}
      {Object.entries(TypeObject).map(([key, value]) => {
        if (value[0] === table[row].type) {
          let type = value[1];
          return (
            <>
              <TypeClassButton
                id={"typeQuickSearch"}
                disabled={DISABLED_CONDITION}
                onClick={() => handleClickType(type, key, value[0], value[2])}
              >
                {type}
              </TypeClassButton>
            </>
          );
        }
      })}
      {!table[row].type || !table[row].class ? ("") : (", ")}
      {Object.entries(ClassObject).map(([key, value]) => {
        if (table[row].type != "pt") {
          if (value[0] === table[row].class) {
            let classNumber = value[1];
            return (
              <>
                <TypeClassButton
                  id={"classQuickSearch"}
                  disabled={DISABLED_CONDITION}
                  onClick={() =>
                    handleClickClass(classNumber, key, `${value[0]}`, value[2])
                  }
                >
                  {classNumber}
                </TypeClassButton>
              </>
            );
          }
        }
      })}
    </div>
  );
}

export default TypeClass;
